// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
export class SelectedOrgMethod {
    static getSelectedOrg(selectedOrgId = '') {
      
      let selectedOrg = '';
      if ( selectedOrgId != null && selectedOrgId !== 'All' && selectedOrgId.length > 0 ) {
        selectedOrg = selectedOrgId;
      }
      return selectedOrg;
    }
  }
